import {
  Clock, Loader2, CheckCircle2, AlertTriangle, Ban, UserCheck, ShieldAlert, Timer,
} from "lucide-react";

export const CONNECTOR_META = {
  azure_ad: { label: "Azure AD / Entra", cls: "bg-blue-100 text-blue-800" },
  helix: { label: "BMC Helix", cls: "bg-purple-100 text-purple-800" },
  rest_api: { label: "REST API", cls: "bg-teal-100 text-teal-800" },
  rpa: { label: "RPA bot (legacy)", cls: "bg-orange-100 text-orange-800" },
  manual: { label: "Manual analyst", cls: "bg-neutral-100 text-neutral-700" },
};
export const ACTIONS = ["provision", "grant", "revoke", "modify"];

export const JOB_STATUS = {
  open: { label: "Open", cls: "bg-neutral-100 text-neutral-700", icon: Clock },
  in_progress: { label: "In progress", cls: "bg-amber-100 text-amber-800", icon: Loader2 },
  completed: { label: "Completed", cls: "bg-green-100 text-green-800", icon: CheckCircle2 },
  partially_completed: { label: "Partial", cls: "bg-red-100 text-red-800", icon: AlertTriangle },
  failed: { label: "Failed", cls: "bg-red-100 text-red-800", icon: AlertTriangle },
  cancelled: { label: "Cancelled", cls: "bg-neutral-200 text-neutral-500", icon: Ban },
};
export const TASK_STATUS = {
  pending: { label: "Pending", cls: "bg-neutral-100 text-neutral-600", icon: Clock },
  running: { label: "Running", cls: "bg-amber-100 text-amber-800", icon: Loader2 },
  awaiting_approval: { label: "Awaiting approval", cls: "bg-indigo-100 text-indigo-800", icon: UserCheck },
  awaiting_mfa: { label: "Awaiting MFA", cls: "bg-orange-100 text-orange-800", icon: ShieldAlert },
  completed: { label: "Done", cls: "bg-green-100 text-green-800", icon: CheckCircle2 },
  failed: { label: "Failed", cls: "bg-red-100 text-red-700", icon: AlertTriangle },
};

export const emptyTask = () => ({ app_name: "", connector: "manual", action: "provision", target: "", requires_approval: false, requires_mfa: false, approver: "" });

export function slaLabel(mins) {
  if (mins == null) return "";
  const past = mins < 0;
  const m = Math.abs(mins);
  const h = Math.floor(m / 60);
  const txt = h >= 1 ? `${h}h ${m % 60}m` : `${m}m`;
  return past ? `${txt} overdue` : `${txt} left`;
}

export function SlaBadge({ job }) {
  if (job.sla_started === false) {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-neutral-100 text-neutral-500" data-testid="sla-badge">
        <Clock className="w-3 h-3" /> SLA not started
      </span>
    );
  }
  if (job.sla_minutes_left == null) return null;
  const cls = job.sla_breached ? "bg-red-100 text-red-800" : job.sla_at_risk ? "bg-amber-100 text-amber-800" : "bg-neutral-100 text-neutral-600";
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${cls}`} data-testid="sla-badge">
      <Timer className="w-3 h-3" /> {slaLabel(job.sla_minutes_left)}
    </span>
  );
}

export function Pill({ map, status }) {
  const m = map[status] || map.open || { label: status, cls: "bg-neutral-100 text-neutral-600", icon: Clock };
  const Icon = m.icon;
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${m.cls}`}>
      <Icon className={`w-3 h-3 ${status === "running" ? "animate-spin" : ""}`} /> {m.label}
    </span>
  );
}

export function StatCard({ label, value, cls, bg, icon: Icon, testid }) {
  return (
    <div className={`rounded-lg p-3 ${bg}`} data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-neutral-600">{label}</span>
        <Icon className={`w-4 h-4 ${cls}`} />
      </div>
      <p className={`text-2xl font-bold mt-1 ${cls}`}>{value}</p>
    </div>
  );
}
